import {
  ApprovalsMutationsCreateApprovalsApprovalFlowArgs as ApprovalFlowArgs,
  UpdateApprovalFlowDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateApprovalFlow = () => {
  const [update, { loading }] = useMutation(UpdateApprovalFlowDocument, {
    extractorFn: (data) => data.approvalsMutations.updateApprovalsApprovalFlow,
  })

  return {
    loading,
    updateApprovalFlow(id: number, data: ApprovalFlowArgs) {
      return update({
        variables: {
          id,
          ...data,
        },
      })
    },
  }
}
